
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { QuestionModel } from './Entities.GormCrm.Question';
import { Model, ModelProperty } from 'models/Model';


export class QuestionDtoModel extends Model<QuestionDtoModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'question', type: 'QuestionModel', languageString: 'questionDto.property.question', isHidden: true, isObject: true, new: () => { return new QuestionModel }, properties: () => { return QuestionModel.classProperties } },
		{ name: 'productIds', type: 'string[]', languageString: 'questionDto.property.productIds', isArray: true }
	];
	[key: string]: any;
	
	public question?: QuestionModel;
	public productIds: string[];
    
	constructor(){
		super();
		this.question = undefined;
		this.productIds = [];
		
	}
	getProperties(){
		return QuestionDtoModel.classProperties;
	}
}

